import {
  LanguageCode,
  LanguageCodes,
} from '@app-shared/enums/language-codes.enum';
import { MapWithDefault } from '@app-shared/functions/helpers.functions';

export type EmailLanguageType =
  'de' | 'ch' | 'en' | 'es' | 'fr' | 'it' | 'cs' | 'nl';

export interface IPreferredEmailLanguageResponse {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  company_name: string;
  country: {
    id: number;
    name: string;
  };
  active: boolean;
  email_language: EmailLanguageType;
}

export const languageCodeToEmailLanguageTypeMap = new MapWithDefault<
  LanguageCodes,
  EmailLanguageType
>('en');

languageCodeToEmailLanguageTypeMap.set(LanguageCode.DE_DE, 'de');
languageCodeToEmailLanguageTypeMap.set(LanguageCode.DE_CH, 'ch');
languageCodeToEmailLanguageTypeMap.set(LanguageCode.EN_GB, 'en');
languageCodeToEmailLanguageTypeMap.set(LanguageCode.ES_ES, 'es');
languageCodeToEmailLanguageTypeMap.set(LanguageCode.FR_FR, 'fr');
languageCodeToEmailLanguageTypeMap.set(LanguageCode.IT_IT, 'it');
languageCodeToEmailLanguageTypeMap.set(LanguageCode.CS_CZ, 'cs');
languageCodeToEmailLanguageTypeMap.set(LanguageCode.NL_BE, 'nl');

export const emailLanguageToLanguageCodeMap = new Map<
  EmailLanguageType,
  LanguageCodes
>([
  ['de', 'de-DE'],
  ['ch', 'de-CH'],
  ['en', 'en-GB'],
  ['es', 'es-ES'],
  ['fr', 'fr-FR'],
  ['it', 'it-IT'],
  ['cs', 'cs-CZ'],
  ['nl', 'nl-BE'],
]);
